import { useState, type FC } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'

import SchoolItem from 'app/KinerjaKSPage/components/School/SchoolItem'

import type { Schools } from 'types/kinerja-ks'

interface SchoolListProps {
  isLoading?: boolean
  data?: Schools
  onClick?: ({ id }: { id: string }) => void
}

const SchoolList: FC<SchoolListProps> = ({
  isLoading = false,
  data,
  onClick,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(false)

  if (!isLoading && !data) {
    throw new Error(
      'Property `data` is required for `SchoolList` component to work'
    )
  }

  if (isLoading) {
    return (
      <>
        <Shimmer width={128} height={22} />

        <div className="grid grid-cols-2 gap-6">
          {Array.from({ length: 5 })?.map((_, index) => (
            <SchoolItem isLoading key={index} />
          ))}
        </div>
      </>
    )
  }

  return (
    <>
      <Text variant="heading-md">Daftar Sekolah</Text>

      {data.length === 0 && <>Tidak ada sekolah untuk ditampilkan</>}

      <div className="grid grid-cols-2 gap-6">
        {data.map((school, idx) => {
          return (
            <SchoolItem
              key={`school-${idx}`}
              data={school}
              disabled={isClicked}
              badgeStatus={school.state}
              onClick={() => {
                if (school?.npsn) {
                  setIsClicked(true)
                  onClick?.({ id: school?.npsn })
                }
              }}
            />
          )
        })}
      </div>
    </>
  )
}
export default SchoolList
